import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/chi-sono", label: "Chi sono" },
  { to: "/servizi", label: "Servizi" },
  { to: "/eventi", label: "Eventi" },
  { to: "/blog", label: "Blog" },
  { to: "/prenota", label: "Prenota" },
  { to: "/contatti", label: "Contatti" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        scrolled ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-white/10" : "bg-[#0A0A0A]/40 backdrop-blur-md border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <span className="bg-white rounded-md px-2.5 py-1.5 flex items-center">
            <img src="https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/dcxb31ag_541836134_1192345226267593_2562402301226683083_n.jpg" alt="MS Coach — Mirko Scravaglieri" className="h-7 md:h-8 w-auto" />
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm tracking-wide transition-colors hover:text-[#C19A5B] ${
                location.pathname === l.to ? "text-[#C19A5B]" : "text-zinc-300"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/contatti"
            data-testid="nav-cta"
            className="rounded-full bg-[#C19A5B] text-black text-sm font-semibold px-5 py-2.5 hover:bg-[#D4AF37] transition-colors"
          >
            Colloquio gratuito
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#0A0A0A]/98 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="text-zinc-200 text-lg py-1" data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}-mobile`}>
              {l.label}
            </Link>
          ))}
          <Link to="/contatti" className="mt-2 rounded-full bg-[#C19A5B] text-black text-center font-semibold px-5 py-3">
            Colloquio gratuito
          </Link>
        </div>
      )}
    </header>
  );
};
